import { Avatar, Box, Grid, Typography, TextField, InputAdornment } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom'
import { getArticles, getArticlesById } from '../../redux/actions/KnowledgeBase/article';
import Breadcrumbs from "./../common2/Breadcrumbs";
import parse from 'html-react-parser';
import PrintArticleWrapper from './PrintArticleWrapper';
import FileViewFromBlobUrl from '../MobileComponents/MobileCommon/FileView';
import SearchIcon from "@mui/icons-material/Search";

function ViewArticle() {
    const param = useParams();
    const dispatch = useDispatch();
    const [articleVal,setArticleVal] = useState<any>(null);
    const [searchData, setSearchData] = useState("");
    const [list, setList] = useState([]);
    useEffect(()=>{
        dispatch(getArticles(getCallback))
    },[])
    const getCallback = (resStatus:string,res:any)=>{
        if(resStatus==="0"){
            setList(res.filter((i:any)=>i.isActive));
        }
    }
    useEffect(()=>{
        if(param?.id){
            dispatch(getArticlesById(param?.id,getArticlesByIdCB))
        }
    },[param?.id])
    const getArticlesByIdCB = (resStatus: string, res: any) => {
        if (resStatus === "0"){
//             console.log("getArticlesByIdCB", res, resStatus)  
            setArticleVal(res)  
        }
    }
    //Search Handler
    const handleSearch = (e: any) => {
        setSearchData(e.target.value);
    };
    return (
        <Box className="p-2">
            <Breadcrumbs
                data={[
                    {
                        title: 'Knowledge Base ',
                        path: '/KnowledgeBase'
                    },
                    {
                        title: 'Article List ',
                        path: '/ArticlesList'
                    },
                    {
                        title: `View Article`,
                        path: `${param.id ? "/ViewArticle/" + param.id : "/ViewArticle"}`
                    }
                ]
                }
            />
            <Box className="pt-1"></Box> 
                <Grid container spacing={1}>
                    <Grid item xs={8}>
                        <PrintArticleWrapper title={`# Article ID : ${articleVal?.id}`} name="Article" >
                            <Box className="white-bg article-viewer-box p-2">
                                {articleVal &&<>

                                    <Typography variant="h4">
                                        {articleVal?.name}
                                    </Typography>
                                    <hr/>

                                    {parse(`${articleVal?.body || ""}`)}
                                </>}
                            </Box>
                        </PrintArticleWrapper>
                        {articleVal?.articleAttachmentList?.length > 0 && (
                        <>
                            <hr />
                            <Box className={`white-bg p-2`}>
                                <Typography variant="h6" gutterBottom>
                                    Attachments
                                </Typography>
                                <Box className={`row`}>
                                    {articleVal?.articleAttachmentList?.map((i: any, index: number) => {
                                        return (
                                            <Box className="col-auto p-3p" key={index}>
                                                <FileViewFromBlobUrl url={i.attachmentPath} />
                                            </Box>
                                        );
                                    })}
                                </Box>
                            </Box>
                        </>
                        )}
                    </Grid>
                    <Grid item xs={4}>
                        <aside className='aside stickyAside'>
                            <Box className="white-bg p-2 articles-lists asideScroll">
                            {/* <Typography variant="h6">
                                    All Articles
                                </Typography> */}
                            <Box display="flex" alignItems="center" justifyContent="space-between">
                                <Typography variant="h6">
                                    All Articles
                                </Typography>
                                <TextField
                                    size="small"
                                    placeholder="Search..."
                                    value={searchData}
                                    onChange={handleSearch}
                                    className="articleSearch"
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start" sx={{paddingLeft: "5px"}}>
                                                <SearchIcon fontSize="small" />
                                            </InputAdornment>
                                        ),
                                    }}
                                />
                            </Box>
                            <hr />
                            {/*Render Dynamically Based On Search*/}
                            {(() => {
                                const filteredList = list.filter((i: any) => {
                                    const objVals = `${i.name} ${i.keywords}`.toLowerCase();
                                    return objVals.indexOf(searchData.toLowerCase()) >= 0;
                                });
                                if (filteredList.length === 0) {
                                    return (
                                        <Typography
                                            variant="body2"
                                            sx={{
                                                textAlign: "center",
                                                py: 2,
                                                opacity: 0.8
                                            }}
                                        >
                                            No records found...
                                        </Typography>
                                    );
                                }
                                return filteredList.map((i: any, index: number) => (
                                    <React.Fragment key={index}>
                                        <ArticleThumb data={i} />
                                    </React.Fragment>
                                ));
                            })()}
                            </Box>
                        </aside>
                    </Grid>
                </Grid>
        </Box>
    )
}

const ArticleThumb = (props:any) =>{
    const {data} = props;
    const navigate = useNavigate();
    const { id } = useParams();
    const isActive = String(data?.id) === String(id);
    return(<>
        <Grid
            onClick={() => { navigate(`/ViewArticle/${data?.id}`) }}
            container
            alignItems={"center"}
            className={`pb-1 cursor-pointer aid_list_items ${isActive ? "active" : ""}`}
            spacing={1}
            sx={{ marginTop:"0px !important"}}
        >
            <Grid item xs={3}>
                <Avatar
                    // className="iconAvatar contact-popup-avatar"
                    alt={"Thumb Image"}
                    src={data?.thumbnailIconPath}
                    onClick={() => { }}
                    sx={{height:40,width:40}}
                    // height="50px"
                    // width="50px"
                />
            </Grid>
            <Grid item xs={9}>
                <Typography variant='body2'>
                    {data?.name || "Article Name"}
                </Typography>
            </Grid>
        </Grid>
    </>)
}
export default ViewArticle
